import { Alert, Button } from 'antd'
import React from 'react'
import type { FormFooterProps } from '../../../../types'
import { Horizontal } from '@gravitate-js/excalibrr'
export function FormFooter({ isFormChanged, invoiceStatus, isPending, onSave, onCancel }: FormFooterProps) {
  return (
    <Horizontal justifyContent='flex-end' verticalCenter>
      <Horizontal gap={8} verticalCenter>
        {isFormChanged && invoiceStatus !== 'No Invoice' && (
          <Alert
            message='You may save your changes, but they will not impact invoices until the next invoice cycle.'
            type='warning'
            showIcon
            style={{
              margin: 0,
              padding: '4px 12px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
            }}
          />
        )}
        {isFormChanged && (
          <>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type='primary' onClick={onSave} loading={isPending}>
              Save Changes
            </Button>
          </>
        )}
      </Horizontal>
    </Horizontal>
  )
}
